import React, { useEffect, useState } from 'react';
import styles from '../../styles/ReporteCalificacionesStyles/ReporteCalificaciones.module.css';
import { getCycles } from '../../api/ciclosEscolares';
import { getSeccionesAcademicas } from '../../api/secciones_academicas';
import { PARCIALES, PARCIAL_DEFAULT } from '../../constants/parciales';

/**
 * Filtros del Reporte de Captura de Calificaciones.
 *
 * Props:
 *  - filters: { id_ciclo_escolar, id_campus, id_seccion, parcial }
 *  - onChange(key, value)
 *  - onGenerate()
 *  - loading: boolean
 *  - onContextResolved({ ciclo, campus, seccion, parcial }): callback opcional
 *    para que el padre conozca los nombres legibles seleccionados (para XLS).
 */
function FiltrosReporte({ filters, onChange, onGenerate, loading, onContextResolved }) {
  const [ciclos, setCiclos] = useState([]);
  const [secciones, setSecciones] = useState([]);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      getCycles().catch(() => []),
      getSeccionesAcademicas().catch(() => []),
    ]).then(([cic, sec]) => {
      if (!mounted) return;
      setCiclos(Array.isArray(cic) ? cic : []);
      setSecciones(Array.isArray(sec) ? sec : []);
    });
    return () => { mounted = false; };
  }, []);

  // Garantizar valor por defecto del parcial al montar
  useEffect(() => {
    if (!filters.parcial) {
      onChange('parcial', PARCIAL_DEFAULT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resolveContext = () => {
    const ciclo = ciclos.find(c => String(c.id) === String(filters.id_ciclo_escolar));
    const seccion = secciones.find(s => String(s.id) === String(filters.id_seccion));
    const parcial = PARCIALES.find(p => p.value === filters.parcial);
    return {
      ciclo: ciclo ? (ciclo.name || ciclo.nombre_ciclo) : 'Todos',
      seccion: seccion ? seccion.nombre : 'Todas',
      parcial: parcial ? parcial.label : (filters.parcial || ''),
    };
  };

  const handleGenerate = () => {
    if (typeof onContextResolved === 'function') {
      onContextResolved(resolveContext());
    }
    onGenerate();
  };

  const disabled = loading || !filters.id_ciclo_escolar || !filters.parcial;

  return (
    <section className={styles.filtersSection}>
      <div className={styles.filtersRow}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Ciclo Escolar *</label>
          <select
            className={styles.filterSelect}
            value={filters.id_ciclo_escolar || ''}
            onChange={(e) => onChange('id_ciclo_escolar', e.target.value)}
          >
            <option value="">Selecciona un ciclo</option>
            {ciclos.map(c => (
              <option key={c.id} value={c.id}>{c.name || c.nombre_ciclo}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Sección</label>
          <select
            className={styles.filterSelect}
            value={filters.id_seccion || ''}
            onChange={(e) => onChange('id_seccion', e.target.value)}
          >
            <option value="">Todas</option>
            {secciones.map(s => (
              <option key={s.id} value={s.id}>{s.nombre}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Parcial *</label>
          <select
            className={styles.filterSelect}
            value={filters.parcial || PARCIAL_DEFAULT}
            onChange={(e) => onChange('parcial', e.target.value)}
          >
            {PARCIALES.map(p => (
              <option key={p.value} value={p.value}>{p.label}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup} style={{ flex: '0 0 auto', minWidth: 'auto' }}>
          <label className={styles.filterLabel}>&nbsp;</label>
          <button
            type="button"
            className={styles.generateButton}
            onClick={handleGenerate}
            disabled={disabled}
          >
            {loading ? 'Generando...' : 'Generar Reporte'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default FiltrosReporte;
